import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getDiaryMonthDots,
  getPatientDairies,
} from '../../services/patient/patient.service';

export const fetchDiary = createAsyncThunk(
  'diary/fetchDiary',
  async (
    { patient_id, from, to }: { patient_id: string; from: string; to: string },
    thunkAPI
  ) => {
    try {
      const data: any = await getPatientDairies(patient_id, from, to);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching patients');
    }
  }
);

export const getDiaryMonthDotsThunk = createAsyncThunk(
  'diary/getDiaryMonthDots',
  async (
    { patient_id, from, to }: { patient_id: string; from: string; to: string },
    thunkAPI
  ) => {
    try {
      const data: any = await getDiaryMonthDots(patient_id, from, to);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching diary month dots');
    }
  }
);
